<template>
  <div class="detail">
    <div class="left">
      <div class="container">
        <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="120px" class="demo-ruleForm">
          <el-card class="card-item box-card">
            <div class="card-title clearfix" slot="header">
              <span>基本信息</span>
            </div>
            <div class="card-content">
              <el-row>
                <el-row>
                <el-col :span="22">
                  <el-form-item label="项目名称：" prop="businessName">
                    <el-input v-model="ruleForm.businessName" clearable></el-input>
                  </el-form-item>
                </el-col>
                </el-row>
                <el-row>
                <el-col :span="11">
                  <el-form-item label="项目编码：" prop="businessCode">
                    <el-input v-model="ruleForm.businessCode" clearable></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="11">
                  <el-form-item label="预约人：" prop="applicant">
                    <el-input v-model="ruleForm.applicant" disabled></el-input>
                  </el-form-item>
                </el-col>
                </el-row>
                <el-col :span="11">
                  <el-form-item label="业务类型：" prop="businessType">
                    <el-radio-group v-model="ruleForm.businessType">
                      <el-radio v-for="item in businessTypeList" @change="changeBusinessType" :label="item.id" :key="item.id">{{ item.text }}</el-radio>
                    </el-radio-group>
                  </el-form-item>
                </el-col>
                <el-col :span="11">
                  <el-form-item label="保密性：" prop="secrecyStatus">
                    <el-radio-group v-model="ruleForm.secrecyStatus">
                      <el-radio v-for="item in secrecyStatusList" :label="item.id" :key="item.id">{{ item.text }}</el-radio>
                    </el-radio-group>
                  </el-form-item>
                </el-col>
                <el-col :span="11">
                  <el-form-item v-show="ruleForm.businessType!='QT'" label="业务细分类：" prop="businessClassfy">
                    <el-radio-group v-model="ruleForm.businessClassfy">
                      <el-radio v-for="item in fieldBusClass" :disabled="ruleForm.businessType=='QT'" :label="item.id" @change="changeBusinessClassfy" :key="item.id">{{ item.text }}</el-radio>
                    </el-radio-group>
                  </el-form-item>
                </el-col>
              </el-row>
            </div>
          </el-card>
           
            <el-card class="card-item box-card" v-for="(applyitem,idx) in ruleForm.details" :key="idx">
              
              <div class="card-title clearfix" slot="header">
                <span>{{ convertApplyType(applyitem.applyType) }}场地预约</span>
              </div>
              <div class="card-content">
                  <el-row>
                    <el-col :span="13">
                      <el-form-item label="场地：" :rules="rules.fieldName" :prop="`details.${idx}.fieldName`">
                        <div class="placesChose" style="display: flex">
                          <el-input v-model="applyitem.fieldName" disabled></el-input>
                          <el-button type="primary" style="margin-left:15px" @click="chosePlace(applyitem)">选择</el-button>
                        </div>
                      </el-form-item>
                    </el-col>
                    <el-col :span="22">
                      <el-form-item label="预约时段：" :rules="rules.applyTimeInterval"
                                  :prop="`details.${idx}.applyTimeInterval`">
                        <el-radio-group v-model="applyitem.applyTimeInterval">
                        <el-radio v-for="item in applyTimeIntervalList" @change="changeApplyTimeInterval(idx)" :label="item.id" :key="item.id">{{ item.text }}
                        </el-radio>
                      </el-radio-group>
                      </el-form-item>
                    </el-col>
                    <el-col :span="11">
                      <el-form-item label="预计开始时间：" :rules="rules.applyTime" :prop="`details.${idx}.applyTime`">
                        <el-date-picker
                            v-model="applyitem.applyTime"
                            type="datetime"
                            :disabled="true"
                            value-format="yyyy-MM-dd HH:mm:ss"
                            placeholder="选择日期时间">
                        </el-date-picker>
                      </el-form-item>
                    </el-col>
                    <el-col :span="11">
                      <el-form-item label="预计结束时间：" :rules="rules.useEndTime" :prop="`details.${idx}.useEndTime`">
                        <el-date-picker
                            v-model="applyitem.useEndTime"
                            type="datetime"
                            :disabled="true"
                            value-format="yyyy-MM-dd HH:mm:ss"
                            placeholder="选择日期时间">
                        </el-date-picker>
                      </el-form-item>
                    </el-col>
                    <el-col :span="11">
                      <el-form-item label="预约机位数：" :rules="rules.machines" :prop="`details.${idx}.machines`">
                        <el-input-number v-model="applyitem.machines" :step="1" :min="1"/>
                      </el-form-item>
                    </el-col>
                    <el-col :span="11">
                      <el-form-item label="容纳人数：" :rules="rules.capacity" :prop="`details.${idx}.capacity`">
                        <el-input-number v-model="applyitem.capacity" :step="1" :min="1"/>
                      </el-form-item>
                    </el-col>
                    <el-col :span="22">
                      <el-form-item label="备注：" :rules="rules.remark" :prop="`details.${idx}.remark`">
                        <el-input type="textarea" v-model="applyitem.remark"></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
              </div>
            </el-card>
          
          <!-- <el-dropdown @command="addApplyItem">
            <el-button type="primary">添加场地预约<i class="el-icon-arrow-down el-icon--right"></i></el-button>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item v-for="item in applyTypeList" :command="item.id" :key="item.id">{{ item.text }}</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown> -->
        </el-form>
      </div>
      <el-card class="box-card" style="margin-top: 15px" v-if="ruleForm.processinstanceid">
            <div slot="header" class="clearfix">
                <span>流程信息</span>
            </div>
            <flow-chart ref="flowChart"
                        :auditForm="{}"
                        @getFlowInfoSuccess="getFlowInfoSuccess">
            </flow-chart>
        </el-card>
    </div>

    <el-dialog
        title="场地选择"
        :visible.sync="centerDialogVisible"
        width="1400px"
        center>
            <site ref="site" @getMessage="getMessage"></site>
    </el-dialog>
    <div class="btns">
      <ul>
        <li><a href="#">场地预约</a></li>
      </ul>
      <el-button type="primary" ref="submit" v-debounce="[submitForm,'click',300,'ruleForm']">保存信息</el-button>
      <el-button type="primary" v-debounce="[subForCheck,'click',300,'ruleForm']" v-show="processSubmit">提交</el-button>
      <el-button @click.native="tabsCloseCurrentHandle">返回</el-button>
    </div>
  </div>
</template>
<script>
import {tabsCloseCurrentHandle} from '@/utils/routeTab'
import {mapState} from 'vuex'
import site from '@/components/site.vue'
export default {
  data() {
    return {
      isSaveFlag: true,
      saveFlag: true,
      saveFlags: true,
      saveError: false,
      centerDialogVisible: false,
      dialogVisible: false,
      tableData: [],
      ruleForm: {
        id: '',
        processinstanceid: '',
        historyid: -1,
        secrecyStatus: '0',
        businessType: 'GC',
        applicantId: '',
        applicant: '',
        applyDateString: '',
        applyTimeString: '',
        applyTime: '',
        applyTimeInterval: '',
        businessId: '',
        businessCode: '',
        projectNo: '',
        businessName: '',
        remark: '',
        platformCode: '',
        comeFrom: 'WRITE',
        businessClassfy:'',
        details: [],
        version:'1.0.0',
        tradeOrgId:''
      },
      applyInfo: {
        id: '',
        parentId: '',
        fieldId: '',
        fieldName: '',
        status: '01',
        applyTimeInterval: '1',
        secrecyStatus: '0',
        remark: '',
        applyType: 1,
        applyTime: '',
        useEndTime: '',
        machines: 1,
        capacity: 1,
      },
      subForHieldIds: '',
      rules: {
        fieldName: [
          {required: true, message: '请选择场地', trigger: 'change'}
        ],
        applicant: [
          {required: true, message: '请输入预约人', trigger: 'blur'},
        ],
        applyTime: [
          {required: true, message: '请选择预计开始时间', trigger: ['change','blur']}
        ],
        applyTimeInterval: [
          {required: true, message: '请选择时段', trigger:'blur'}
        ],
        secrecyStatus: [
          {required: true, message: '请选择保密性', trigger: 'change'}
        ],
        businessType:[
          {required: true, message: '请选择业务类型', trigger: 'change'}
        ],
        businessClassfy:[
          {required: true, message: '请选择业务细分类', trigger: 'change'}
        ],
        businessName: [
          {required: true, message: '请输入项目名称/用途', trigger: 'blur'}
        ],
        businessCode: [
          {required: true, message: '请输入项目编号', trigger: 'blur'}
        ],
        useEndTime: [
          {required: true, message: '请输入预计结束时间', trigger: ['change','blur']}
        ],
        machines: [
          {required: true, message: '请输入预约机位数', trigger: 'blur'}
        ],
        capacity: [
          {required: true, message: '请输入预约场地容纳人数', trigger: 'blur'}
        ]
      },
      stringRuleForm:'',
      processSubmit:false,
      taskId:''
    }
  },
  components:{
    site
  },
  created() {
    if (this.$route.query.id) {
      this.getDetailMessage();
      this.isSaveFlag = false;
    }
  },
  mounted() {
    this.$store.dispatch('region/getRegionTree', '');
    this.$store.dispatch('region/getPlaceType', '');
    this.$store.dispatch('region/getSupportingList');
    this.$store.dispatch('region/getBusinessTypeList');
    this.$store.dispatch('region/getSecrecyStatusList');
    this.$store.dispatch('region/getApplyTypeList');
    this.$store.dispatch('region/getApplyTimeIntervalList');
    this.$store.dispatch('region/getFieldBusClass');
    this.$store.dispatch('region/getFieldLinks');
    this.$store.dispatch('region/getSetimerules');
    
    
    this.ruleForm.applicantId = this.userinfo.id
    this.ruleForm.applicant = this.userinfo.displayName
    
  },
  computed: {
    ...mapState({
      supportingList: (state) => state.region.supportingList,
      businessTypeList: (state) => state.region.businessTypeList,
      secrecyStatusList: (state) => state.region.secrecyStatusList,
      applyTypeList: (state) => state.region.applyTypeList,
      applyTimeIntervalList: (state) => state.region.applyTimeIntervalList,
      fieldBusClass: (state) => state.region.fieldBusClass,
      fieldLinks: (state) => state.region.fieldLinks,
      setimerules: (state) => state.region.setimerules,
      userinfo: (state) => state.user,
    })
  },
  methods: {
    addApplyItem(cmd) {//新增场地模块
      let applyInfo = {...this.applyInfo}
      applyInfo.applyType = cmd
      this.ruleForm.details.push(applyInfo)
    },
    convertApplyType(type) {//显示是啥场地 
      var items = this.applyTypeList.filter(t => t.id == type);
      if (items && items.length > 0) {
        return items[0].text;
      }
      return "";
    },
    getDetailMessage() {//单个查询
      this.$http.get('/field/applymanage/get?id=' + this.$route.query.id)
          .then(res => {
            console.log('预约修改detail', res.data.data);
            this.$nextTick(() => {
              this.ruleForm = res.data.data;
              this.$nextTick(function () {
                this.$refs.flowChart.getFlow(this.ruleForm.processinstanceid)
              });
              this.ruleForm.secrecyStatus=String(this.ruleForm.secrecyStatus)
              if(!this.ruleForm.applyLinks){
                this.ruleForm.details=[];
                this.ruleForm.businessClassfy=''
                this.stringRuleForm=JSON.stringify(this.ruleForm)
                return;
              }
              if(this.ruleForm.details.length>0){
                for(var i in this.ruleForm.details){
                  this.ruleForm.details[i].applyTimeInterval=String(this.ruleForm.details[i].applyTimeInterval)
                }
                this.stringRuleForm=JSON.stringify(this.ruleForm)
              }
              
            })
          })
    },
    async subForCheck(formName) {//提交
      if(this.stringRuleForm!=JSON.stringify(this.ruleForm)){
        await this.submitForm()
        if (this.saveError){
          this.saveError=false
          return
        }
      }
      this.ruleForm.variables={}
      this.$set(this.ruleForm.variables,'commit' , true);
      this.$set(this.ruleForm.variables,'opinion' , '请审核');
      this.$set(this.ruleForm,'taskId' ,this.taskId);
      this.$http.post('/field/applymanage/processSubmit', this.ruleForm)
          .then(res => {
            if (res.data.code == 1) {
              this.$message.success(res.data.msg);
              this.tabsCloseCurrentHandle()
            }else {
              this.$message.error(res.data.msg);
            }
          })
    },
    submitForm() {//保存
      this.$refs.ruleForm.validate((valid)=>{
        if(valid){
          if (this.saveFlags) {
            this.saveFlags = false;
            this.$http.post('/field/applymanage/save', JSON.stringify(this.ruleForm))
                .then(res => {
                  console.log('save', res)
                  if (res.data.code == 1) {
                    this.$message.success(res.data.msg);
                    this.$set(this.ruleForm,'id',res.data.data.id)
                    this.$set(this.ruleForm,'processinstanceid',res.data.data.processinstanceid)
                    this.$router.push({name:'appointmentExit',query:{id:res.data.data.id}});
                    this.stringRuleForm=JSON.stringify(this.ruleForm)
                    this.subForHieldIds = res.data.data.id;
                    setTimeout(() => {
                      this.saveFlags = true;
                    }, 3000)
                    this.$nextTick(function () {
                      this.$refs.flowChart.getFlow(this.ruleForm.processinstanceid)
                    });
                  } else {
                    this.saveError=true
                    setTimeout(() => {
                      this.saveFlags = true;
                    }, 3000)
                    this.$message.error(res.data.msg);
                  }
                })
          }
        }
      })
      
    },
    tabsCloseCurrentHandle() {//返回列表页
      this.tabsCloseHandle('appointmentExit');
      this.$router.push({path:'/appointmentList'});
    },
    chosePlace(applyItem) {//打开选择场地弹框
      this.centerDialogVisible = true;
      this.$nextTick(()=>{
        this.$refs.site.curApplyInfo=applyItem;
        this.$refs.site.getAllPlaceStatus();
      });
    },
    getMessage(data){//获取场地信息
      this.centerDialogVisible=false;
    },
    changeBusinessClassfy(){//切换细分类
      this.ruleForm.details=[];
      var arr=[];

      if(this.fieldLinks[this.ruleForm.businessClassfy]){
        this.ruleForm.applyLinks=this.fieldLinks[this.ruleForm.businessClassfy];
        arr=this.fieldLinks[this.ruleForm.businessClassfy].split(",");
      }

      for(var j in arr){
        this.addApplyItem(arr[j])
      }
    },
    changeBusinessType(){//切换业务分类
      if(this.ruleForm.businessType=='QT'){
        this.$set(this.ruleForm,'businessClassfy','9')
      }else{
        this.$set(this.ruleForm,'businessClassfy','1')
      }
      this.changeBusinessClassfy()
    },
    changeApplyTimeInterval(idx){//切换时间段
      var index=this.ruleForm.details[idx].applyTimeInterval;
      var time1,time2;
      if(this.setimerules.start[index]){
        time1=(this.ruleForm.details[idx].applyTime).substring(0,10)+' '+this.setimerules.start[index];
        this.$set(this.ruleForm.details[idx],'applyTime',time1)
      }

      if(this.setimerules.end[index]){
        time2=(this.ruleForm.details[idx].useEndTime).substring(0,10)+' '+this.setimerules.end[index];
        this.$set(this.ruleForm.details[idx],'useEndTime',time2)
      }
    },
    getFlowInfoSuccess(resData) {
        this.processSubmit = false;
        if (resData.taskId !== '') {
            resData.buttons.forEach(item => {
                if (item.type == 1) {
                    this.processSubmit = true
                }
            })
            this.taskId=resData.taskId
        }
    },
  },
}
</script>
<style lang="scss" scoped>
.detail {
  width: 1360px;
  display: flex;
  margin: 18px auto;

  .left {
    width: 1200px;
    .card-item {
      width: 100%;
      margin-top: 15px;
    }
    .demo-ruleForm {
      display: flex;
      flex-wrap: wrap;
      padding: 0;

      .el-form-item {
        /deep/ .el-input-number--medium,/deep/ .el-date-editor ,/deep/ .el-input ,/deep/ .el-input--medium .el-input__inner {
          width: 100%;
        }
      }
      .card-content{
        // padding: 22px 50px 0;
      }

      .el-form-item:nth-last-child(1) {
        width: 100%;
      }
    }
    .el-dropdown{
      margin: 25px auto;
    }

    /deep/ .el-radio {
      margin-right: 4px !important;
    }
  }

  .btns {
    width: 150px;
    height: auto;
    display: flex;
    flex-direction: column;
    align-items: center;
    border: 1px solid #ebeef5;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, .1);
    background-color: #fff;
    color: #303133;
    text-align: center;
    padding: 0 10px 10px 10px;
    position: fixed;
    right: 150px;
    top: 143px;

    .el-button--medium {
      width: 100px;
      margin: 5px 0;
    }

    ul {
      width: 100px;
      margin-bottom: 5px;

      li {
        a {
          display: block;
          padding: 10px 0;
          text-align: center;
          border-bottom: 1px solid #ddd;
          position: relative;
          color: #1f59a3;
          cursor: pointer;
        }
      }
    }
  }
}

@media screen and (max-width: 1680px) {
  .detail {
    .left {
      width: 1070px;
    }

    .btns {
      right: 80px;
    }
  }
}

@media screen and (max-width: 1600px) {
  .detail {
    .left {
      width: 950px;
    }
    .btns {
      right: 80px;
    }
  }
}

@media screen and (max-width: 1440px) {
  .detail {
    .left {
      width: 800px;
    }
    .btns {
      right: 110px;
    }
  }
}
</style>